import React from 'react';
import PropTypes from 'prop-types';

import ReviewComponent from './ReviewComponent';

const PDPFabricReviewsUI = ({ reviews, showTitle = true }) => {
  if (!reviews?.length) return null;

  return (
    <div className="mx-0 my-4">
      {showTitle && (
        <h3 className="text-base font-bold m-0 pb-2 [border-bottom:1px_solid_#f1f1f1]">
          Reviews
        </h3>
      )}
      {reviews.map(review => (
        <ReviewComponent
          rate={review.rate}
          keyId={review.id}
          full_name={review.full_name}
          location={review.location}
          date={review.date}
          review={review.review}
        />
      ))}
    </div>
  );
};

PDPFabricReviewsUI.propTypes = {
  reviews: PropTypes.array,
  showTitle: PropTypes.bool,
};

export default PDPFabricReviewsUI;
